/* eslint-disable react/no-unknown-property */
"use client";
import React from "react";
import { setCookie } from "helpers/cookies";
import { setJobViewCookiesTracker, viewJobSourceTracker } from "components/ReportTracker/util";

import JobCardMobile from "app/(new-pages)/components/JobCard/mobile/index.mobile";

const CardMobile = ({
  job,
  lang = "en-us",
  cardType = undefined,
  reco_from = undefined,
  query_id = undefined
}) => {
  const { job_url } = job || {};

  const onTouchCard = (e) => {
    e.stopPropagation();
    setJobViewCookiesTracker(setCookie, {
      source: viewJobSourceTracker.jobsHiring,
      reco_from: reco_from || null,
      query_id: query_id || null
    });
    window.location.href = "/" + lang + job_url;
  };

  return <JobCardMobile job={job} langKey={lang} onTouchCard={onTouchCard} />;
};

export default CardMobile;
